import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Navbar } from "../components/Navbar";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Mail, Loader2, ArrowLeft, CheckCircle } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function ForgotPasswordPage() {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSubmitted(true);
      toast.success("Email inviata!");
    } catch (error) {
      const message = error.response?.data?.detail || "Errore nell'invio dell'email";
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="forgot-password-page">
      <Navbar />
      
      <div className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-md animate-fadeIn">
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-8">
            {submitted ? (
              <div className="text-center">
                <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CheckCircle className="w-8 h-8 text-emerald-600" />
                </div>
                <h1 className="text-2xl font-bold text-slate-900 mb-2">Email inviata!</h1>
                <p className="text-slate-600 mb-6">
                  Se l'indirizzo <strong>{email}</strong> è registrato, riceverai un'email con le istruzioni per reimpostare la password.
                </p>
                <p className="text-sm text-slate-500 mb-6">
                  Controlla anche la cartella spam se non trovi l'email.
                </p>
                <Link to="/login">
                  <Button className="bg-[#004E64] hover:bg-[#003847] text-white">
                    <ArrowLeft className="w-4 h-4 mr-2" />
                    Torna al login
                  </Button>
                </Link>
              </div>
            ) : (
              <>
                <div className="text-center mb-8">
                  <h1 className="text-2xl font-bold text-slate-900">Password dimenticata?</h1>
                  <p className="text-slate-600 mt-2">
                    Inserisci la tua email e ti invieremo un link per reimpostare la password.
                  </p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-5" data-testid="forgot-password-form">
                  <div>
                    <Label htmlFor="email" className="text-slate-700">Email</Label>
                    <div className="relative mt-1.5">
                      <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                      <Input
                        id="email"
                        name="email"
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="mario@esempio.ch"
                        className="pl-10"
                        data-testid="forgot-email"
                      />
                    </div>
                  </div>

                  <Button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-[#DA291C] hover:bg-[#B91C1C] text-white h-11 font-semibold"
                    data-testid="forgot-submit"
                  >
                    {loading ? (
                      <>
                        <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                        Invio in corso...
                      </>
                    ) : (
                      "Invia link di reset"
                    )}
                  </Button>
                </form>

                <div className="mt-6 text-center">
                  <Link 
                    to="/login" 
                    className="text-sm text-[#004E64] font-semibold hover:underline inline-flex items-center"
                    data-testid="back-to-login"
                  >
                    <ArrowLeft className="w-4 h-4 mr-1" />
                    Torna al login
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
